import { MOVABLE_INK_INTEGRATIONS_URL } from 'api/MovableInkIntegrationsAPI';
import { useRestQuery } from 'utils/hooks/api/useRestQuery';
import { MovableInkIntegration } from '../types';
import { useFeatureFlag } from 'utils/hooks/useFeatureFlag';
import { MI } from '../featureFlags';

type MovableInkIntegrationRequest = {
  accountIds?: string[];
};

type MovableInkIntegrationResponse = MovableInkIntegration[];

export const useGetIntegrations = () => {
  const isFeatureEnabled = useFeatureFlag(MI) ?? false;
  const {
    data = [],
    isLoading,
    isError,
    isSuccess,
    refetch,
  } = useRestQuery<MovableInkIntegrationResponse, MovableInkIntegrationRequest>(
    MOVABLE_INK_INTEGRATIONS_URL,
    {},
    { refetchOnMount: false, staleTime: Infinity, enabled: isFeatureEnabled },
  );

  return {
    data,
    isLoading,
    isError,
    isSuccess,
    refetch,
  };
};
